// https://codesandbox.io/s/915qlr56rp?file=/src/index.tsx
// https://codesandbox.io/s/ol11mmk30z?file=/src/InputForm/index.js

import React from "react";

import AuthApi from "../Route/AuthApi";
import Cookies from "js-cookie";

import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import EmailIcon from "@material-ui/icons/Email";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import { Avatar, Grid, TextField, Button, Typography } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";

import LockScreen from "./LockScreen";

export default function Login(props) {
  //   const {
  //     // values: { name, email, password, confirmPassword },
  //     values: {email },
  //     errors,
  //     touched,
  //     handleSubmit,
  //     handleChange,
  //     isValid,
  //     setFieldTouched,
  //   } = props;
  console.log("Login Page Called");
  const Auth = React.useContext(AuthApi);
  const handleSignIn = () => {
    Auth.setAuth(true);
    Cookies.set("JurniHRLogin", "loginTrue");
  };

  const avatarStyle = { backgroundColor: "#007bff" };
  console.log(props);
  return (
    <div className="login-page">
      <div className="login-box ">
        {/* /.login-logo */}
        {/* <Avatar style={avatarStyle}><LockIcon/></Avatar> */}
        <div className="login-logo">
          <b>Jurni</b>HR
        </div>
        <div className="card">
          <div className="card-body login-card-body">
            {/* <p className="login-box-msg">
              <h3>Sign In</h3>
            </p> */}
            <Grid align="center">
              {/* <Avatar style={avatarStyle}><LockOutlinedIcon/></Avatar> */}
              <Link to="/LockScreen">
                <Avatar style={avatarStyle}>
                  <LockIcon />
                </Avatar>
              </Link>
              <h3>Sign In</h3>
            </Grid>
            <form action="../../index3.html" method="post">
              <div className="input-group mb-3">
                {/* <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                />
                 <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div> */}

                <TextField
                  name="email"
                  //   helperText={touched.email ? errors.email : ""}
                  //   error={Boolean(errors.email)}
                  label="Email"
                  fullWidth
                  //   value={email}
                  //   onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* <EmailIcon /> */}
                        <span className="fas fa-envelope" />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  name="password"
                  //   helperText={touched.password ? errors.password : ""}
                  //   error={Boolean(errors.password)}
                  label="Password"
                  fullWidth
                  type="password"
                  //   value={password}
                  //   onChange={handleChange}
                  whiteSpace="nowrap"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* <LockIcon /> */}
                        <span className="fas fa-lock" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="icheck-primary">
                    {/* <input type="checkbox" id="remember" /> */}
                    {/* <label htmlFor="remember" style={{ fontWeight: 400 }}>
                      Remember Me
                    </label> */}
                    {/* <label htmlFor="remember">Remember Me</label> */}
                    <FormControlLabel
                      control={<Checkbox name="checkedB" color="primary" />}
                      label="Remember me"
                    />
                  </div>
                </div>
                {/* /.col */}
                <div className="col-12">
                  {/* <button type="submit" className="btn btn-primary btn-block">
                    Sign In
                  </button> */}
                  <Link to="/home">
                    <Button
                      // type="submit"
                      renderAs="button"
                      color="primary"
                      variant="contained"
                      fullWidth
                      // component={Link}
                      // to="/home"
                      onClick={handleSignIn}
                    >
                      Sign in
                    </Button>
                  </Link>
                </div>

                {/* /.col */}
              </div>
            </form>
            <div
              className="social-auth-links text-center mb-3"
              style={{ display: "none" }}
            >
              <p>- OR -</p>
              <a href="#" className="btn btn-block btn-primary">
                <i className="fab fa-facebook mr-2" /> Sign in using Facebook
              </a>
              <a href="#" className="btn btn-block btn-danger">
                <i className="fab fa-google-plus mr-2" /> Sign in using Google+
              </a>
            </div>
            {/* /.social-auth-links */}
            <p className="mb-1" style={{ marginTop: "20px" }}>
              <a href="forgot-password.html">I forgot my password</a>
            </p>
            <p className="mb-0">
              <a href="register.html" className="text-center">
                Register a new membership
              </a>
            </p>
          </div>
          {/* /.login-card-body */}
        </div>
      </div>
    </div>
  );
}
